import init from './thing'

const team =
{
    ...init
};

export default team ;
